import Loading from 'app/atoms/Loading';
import { Suspense, useEffect, useState } from 'react';
import './HolidayLikeALocal.scss';
import HolidayLikeALocalPropertyCarousel from './HolidayLikeALocalPropertyCarousel/HolidayLikeALocalPropertyCarousel';
import HolidayLikeALocalImage from './HolidayLikeALocalImage/HolidayLikeALocalImage';
import { useParams } from 'react-router';
import { sanityClient } from '../../../sanity.io/config';
import SanityHeroSection from '../../atoms/Sanity/SanityHeroSection/SanityHeroSection';
import SanityHeader from '../../atoms/Sanity/SanityHeader/SanityHeader';
import { HolidayLikeALocalProps, SanityEventCity } from './HolidayLikeALocal.types';
import SanitySubHeader from '../../atoms/Sanity/SanitySubHeader/SanitySubHeader';
import Copyright from '../../molecules/Footer/Copyright';
import HolidayLikeALocalBody from './HolidayLikeALocalBody/HolidayLikeALocalBody';
import SanityBody from 'app/atoms/Sanity/SanityBody/SanityBody';

function HolidayLikeALocal() {
  const { event } = useParams<{ event: string }>();
  const [data, setData] = useState<HolidayLikeALocalProps>();
  const [whereTo, setWhereTo] = useState<SanityEventCity>();

  useEffect(() => {
    sanityClient.fetch(`*[ _type== "event" && slug.current == "${event.toLowerCase()}"]{ ..., city->, author-> }`).then(response => {
      if (response && response[0]) {
        setData(response[0]);
      }
    });
  }, []);

  useEffect(() => {
    !!data && setWhereTo(data.cities[0]);
  }, [data]);

  return (
    <Suspense
      fallback={
        <div>
          <Loading force={true} />
        </div>
      }
    >
      {data && (
        <>
          <SanityHeroSection heroImageUrl={data.heroImage.asset._ref} />
          <section className="d-flex flex-wrap">
            <div className="holiday-like-a-local-container col-12 col-sm-8">
              <SanityHeader title={data.title} author={data.author?.name} date={data._createdAt} />
              <SanitySubHeader subHeader={data.header} />
              <SanityBody body={data.headerParagraph} />
              {!!data && <HolidayLikeALocalBody content={data.content} />}
              <div className="col-lg-12 col-md-12 copy-right p-0 d-none d-sm-block">
                <Copyright />
              </div>
            </div>
            {whereTo && (
              <HolidayLikeALocalImage
                cities={data.cities}
                whereTo={whereTo}
                setWhereTo={setWhereTo}
                start={data.start}
                end={data.end}
                innerClass={'d-flex'}
              />
            )}
            <div className="col-lg-12 col-md-12 copy-right d-block d-sm-none">
              <Copyright />
            </div>
          </section>
          {whereTo && (
            <HolidayLikeALocalPropertyCarousel
              title="Holiday Hideaways"
              subtitle={`Check more of our favorite holiday homes`}
              city={whereTo.name}
              checkInDate={data.start}
              checkOutDate={data.end}
            />
          )}
        </>
      )}
    </Suspense>
  );
}
export default HolidayLikeALocal;
